import React, { useState, useEffect } from 'react';
import AdminAgencyScheduleManagement from './AdminAgencyScheduleManagement';
import ModalWarn from '../../Components/Modal/Warn/index'
import { rowspan } from '../../utils';

export default function AdminAgencySchedule(props) {

    const [ loading, setLoading] = useState(false);

    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [ pageOptions, setPageOptions ] = useState([]);
    const [ page, setPage ] = useState({
        label: "1", value: "1"
    });

    const [ modalError, setModalError ] = useState(false);

    const [ agencyScheduleManagementList, setAgencyScheduleManagementList ] = useState([ ]);

    const [ totalFilter, setTotalFilter ] = useState("0");

    const [successMsg, setSuccessMsg] = useState();
    
    const [ erroMsg, setErroMsg ] = useState('');

    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(() => {
        async function loadAgencies() {
            setAgencyScheduleManagementList([]);
            setSuccessMsg('');
            setErroMsg('');
            setLoading(true);
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')).cpf_atendente,
                    pagina_atual: "1",
                    qtd_registros: 10
                }),
            };
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/listaHorarioOrgao`, requestOptions).then(function(response) {
                if (response.ok) {
                    response.json().then(function(resp) {
    
                        const maxPageOption = Math.ceil(Number(resp.total) / Number(rangePages.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }
    
                            list.push(obj);
                        }
                        setPageOptions(list);
                        setPage({label: "1", value: "1"});
                        setAgencyScheduleManagementList(rowspan.setTd(resp.horariosOrgao, 'NOME_REDE_ATENDIMENTO'));
                        setTotalFilter(resp.total);
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            setErroMsg(data.message);
                        } else {
                            setErroMsg('Houve algum problema no servidor.');
                        }
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setLoading(false)
                      setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    setModalError(true);
                    console.log('Request error in gestao/listaHorariosOrgao BackendBalcao');
                }
                setLoading(false);
            }).catch(function(err) {
                setLoading(false);
                console.error('Failed retrieving information', err);
            });
        };

        if (props.location?.state?.pagination) {
            setRangePages(props.location.state.pagination.range_page);
            setPage(props.location.state.pagination.page);
            setPageOptions(props.location.state.pagination.page_options);
            setTotalFilter(props.location.state.pagination.total);
            onChangePaginationConfig(props.location.state.pagination.range_page, props.location.state.pagination.page, false)
            setSuccessMsg(props.location?.state?.successMsg);
        } else {
            loadAgencies()
        }        

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.state]);

    const onChangePaginationConfig = async (ranPag, pag, isRanPag) => {
        setSuccessMsg('');
        setErroMsg('');
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')).cpf_atendente,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/listaHorarioOrgao`, requestOptions
        ).then(function(response) {
            if (response.ok) {
                response.json().then(function(data) {
                    // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!

                    const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                    let list = []
                    let obj = {}
                    for(var i = 1; i <= maxPageOption; i++) {
                        obj = {
                            value: String(i),
                            label: String(i)
                        }

                        list.push(obj);
                    }

                    setPageOptions(list);
                    if(isRanPag){
                        setPage({label: "1", value: "1"});
                    }
                    setAgencyScheduleManagementList(rowspan.setTd(data.horariosOrgao, 'NOME_REDE_ATENDIMENTO'));
                    setTotalFilter(data.total);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message);
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                setModalError(true);
                console.log('Request error in gestao/listaHorariosOrgao BackendBalcao');
            }
            setLoading(false);
        }).catch(function(err) {
            setLoading(false);
            console.error('Failed retrieving information', err);
        });
    };

    const onSubmitDelete = async (agencySchedule) => {
        setSuccessMsg('');
        setErroMsg('')
        const user = JSON.parse(localStorage.getItem('user'))
            const requestOptions = {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
            authorization: user ? user.token : '',
            'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
          }),
    
          body: JSON.stringify({
            cpf_gestor: user.cpf_atendente,
            codigo_orgao: agencySchedule.CODIGO_ORGAO,
            dias_semana: agencySchedule.DIAS_SEMANA
          }),
        }
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/horario/apagaHorarioOrgao`, requestOptions)
          .then(function (response) {
            if (response.ok) {
              response.json().then(function(data) {
                props.history.push("/horarios", {pagination: {
                                                        range_page: rangePages,
                                                        page: page,
                                                        page_options: pageOptions,
                                                        total: totalFilter,
                                                    }, successMsg: data.message
                                                });
                setErroMsg('')
              })
            } else {
              response.json().then(function (data) {
                setErroMsg(data.messages ? data.messages : data.message)
                setModalError(true);
              })
            }
          })
          .catch(function (err) {
            console.error('Failed retrieving information', err)
          })
      }

    return(
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <AdminAgencyScheduleManagement
                pageTitle='Gestão de horários de redes de atendimento'
                buttonDetailRoute='/detalharHorarioOrgao'
                buttonEditRoute='/editarHorarioOrgao'
                buttonNextLoading={loading}
                onChangePaginationConfig={onChangePaginationConfig}
                onSubmitDelete={onSubmitDelete}
                searchResult={agencyScheduleManagementList}
                setSearchResult={setAgencyScheduleManagementList}
                history={props.history}
                totalFilter={totalFilter}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                successMsg={successMsg}
                erroMsg={erroMsg}
                setErroMsg={setErroMsg}
                rangePages={rangePages}
                setRangePages={setRangePages}
                modalError={modalError}
                setModalError={setModalError}
            />
        </>
    );
}